var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/eye-slash"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye-slash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8975 7.1025L7.1025 10.8975C6.615 10.41 6.315 9.7425 6.315 9C6.315 7.515 7.515 6.315 9 6.315C9.7425 6.315 10.41 6.615 10.8975 7.1025Z",
    stroke: "#00535C",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.365 4.32749C12.0525 3.33749 10.5525 2.79749 9 2.79749C6.3525 2.79749 3.885 4.35749 2.1675 7.05749C1.4925 8.11499 1.4925 9.89249 2.1675 10.95C2.76 11.88 3.45 12.6825 4.2 13.3275",
    stroke: "#00535C",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.315 14.6475C7.17 15.0075 8.0775 15.2025 9 15.2025C11.6475 15.2025 14.115 13.6425 15.8325 10.9425C16.5075 9.88501 16.5075 8.10751 15.8325 7.05001C15.585 6.66001 15.315 6.29251 15.0375 5.94751",
    stroke: "#00535C",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.6321 9.52515C11.4371 10.5826 10.5746 11.4451 9.51709 11.6401",
    stroke: "#00535C",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.1025 10.8975L1.5 16.5",
    stroke: "#00535C",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16.4995 1.5L10.897 7.1025",
    stroke: "#00535C",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeSlash);
export default __webpack_public_path__ + "static/media/eye-slash.be67f020.svg";
export { ForwardRef as ReactComponent };